import Index from "./Index.jsx";

const REPORTS = {
  INDEX: Index,
};

export default REPORTS;